/**
 * SozialPlus site interactions (vanilla JS — no jQuery/Bootstrap).
 */
function initSite() {
  const nav = document.getElementById("mainNav")
  const navPanel = document.getElementById("navbarResponsive")

  // Mobile nav toggle
  document.querySelectorAll("[data-nav-toggle]").forEach((btn) => {
    btn.addEventListener("click", () => {
      if (!navPanel) return
      const open = navPanel.classList.toggle("is-open")
      btn.setAttribute("aria-expanded", open ? "true" : "false")
    })
  })

  // Close mobile nav after in-page navigation
  const closeNav = () => {
    if (!navPanel) return
    navPanel.classList.remove("is-open")
    document.querySelectorAll("[data-nav-toggle]").forEach((btn) => {
      btn.setAttribute("aria-expanded", "false")
    })
  }

  // Die Ink-Wortmarke (logo-ink.svg) wird per CSS eingefärbt: weiß über dunklem Grund,
  // dunkel/„schwarz“ auf der hellen Frosted-Glass-Nav. Kein Quell-Swap mehr nötig.

  // Dunkle Sektionen (Kontakt, Footer): hier scheint die helle Glas-Nav dunkel/grünlich
  // durch — daher dort dieselbe dunkle Nav (weiße Schrift) wie über dem Hero.
  const darkSections = [...document.querySelectorAll("section#contact, .footer")]

  const navbarCollapse = () => {
    if (!nav) return
    const y = window.scrollY
    const hero = document.getElementById("hero")
    let pastHero = true
    if (hero) {
      pastHero = y + 2 >= hero.offsetTop + hero.offsetHeight
    }
    const navH = nav.offsetHeight || 0
    const overDark = darkSections.some((el) => {
      const r = el.getBoundingClientRect()
      return r.top < navH && r.bottom > 0
    })

    // Über dunklen Sektionen (Kontakt/Footer) dieselbe dunkle Nav mit weißer Schrift
    // wie über dem Hero — also kein helles Frosted-Glass dort.
    nav.classList.toggle("navbar--over-dark", overDark)
    nav.classList.toggle("navbar--light", pastHero && !overDark)
    nav.classList.toggle("navbar--scrolled", y > 12)
  }

  navbarCollapse()
  window.addEventListener("scroll", navbarCollapse, { passive: true })
  window.addEventListener("resize", navbarCollapse, { passive: true })

  // Unterseiten: aktuellen Menüpunkt hervorheben (Wissen, Referenzen, Kontakt)
  const path = window.location.pathname.replace(/\/$/, "") || "/"
  const subpageNav = [
    { prefix: "/wissen", href: "/wissen/" },
    { prefix: "/referenzen", href: "/referenzen/" },
    { prefix: "/kontakt", href: "/kontakt/" },
  ]
  for (const { prefix, href } of subpageNav) {
    if (path !== prefix && !path.startsWith(`${prefix}/`)) continue
    document.querySelectorAll(`#mainNav .nav-link[href="${href}"]`).forEach((a) => {
      a.classList.add("active")
      a.setAttribute("aria-current", "page")
      const li = a.closest(".nav-item")
      if (li) li.classList.add("active")
    })
    break
  }

  // Smooth in-page scroll
  document.querySelectorAll('a.js-scroll-trigger[href*="#"]:not([href="#"])').forEach((link) => {
    link.addEventListener("click", (e) => {
      if (
        location.pathname.replace(/^\//, "") !== link.pathname.replace(/^\//, "") ||
        location.hostname !== link.hostname
      ) {
        return
      }
      const hash = link.hash
      if (!hash || hash.length < 2) return
      const id = hash.slice(1)
      let el = document.getElementById(id)
      if (!el && typeof document.getElementsByName === "function") {
        const named = document.getElementsByName(id)
        el = named.length ? named[0] : null
      }
      if (!el) return
      e.preventDefault()
      const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches
      el.scrollIntoView({ behavior: reduceMotion ? "auto" : "smooth", block: "start" })
      closeNav()
    })
  })

  // Impressum/Datenschutz sind eigene Seiten (/impressum/, /datenschutz/).
  // Alte Deep-Links auf die früheren Modal-Anker leiten wir dorthin weiter.
  const legalHashTargets = {
    impressum: "/impressum/",
    datenschutz: "/datenschutz/",
  }

  const redirectLegalHash = () => {
    const key = location.hash.replace(/^#/, "")
    if (legalHashTargets[key]) {
      location.replace(legalHashTargets[key])
    }
  }

  redirectLegalHash()
  window.addEventListener("hashchange", redirectLegalHash)

  // Copy-to-clipboard fallback for e-mail CTAs (no working mail client required)
  document.querySelectorAll("[data-copy]").forEach((btn) => {
    const label = btn.querySelector(".btn-copy__label") || btn
    const original = label.textContent
    let timer = 0
    btn.addEventListener("click", async () => {
      const value = btn.getAttribute("data-copy")
      if (!value) return
      let ok = false
      try {
        if (navigator.clipboard && navigator.clipboard.writeText) {
          await navigator.clipboard.writeText(value)
          ok = true
        }
      } catch (_) {
        ok = false
      }
      if (!ok) {
        const ta = document.createElement("textarea")
        ta.value = value
        ta.setAttribute("readonly", "")
        ta.style.position = "fixed"
        ta.style.top = "-1000px"
        document.body.appendChild(ta)
        ta.select()
        try {
          ok = document.execCommand("copy")
        } catch (_) {
          ok = false
        }
        document.body.removeChild(ta)
      }
      label.textContent = ok ? "Kopiert ✓" : original
      btn.classList.toggle("is-copied", ok)
      window.clearTimeout(timer)
      timer = window.setTimeout(() => {
        label.textContent = original
        btn.classList.remove("is-copied")
      }, 2000)
    })
  })

  // Section dots + Navbar: aktiven Abschnitt beim Scrollen hervorheben
  const syncAnchoredNav = (activeId) => {
    document.querySelectorAll('#mainNav .nav-link[href^="#"]').forEach((a) => {
      const match = activeId && a.getAttribute("href") === `#${activeId}`
      a.classList.toggle("active", Boolean(match))
      const li = a.closest(".nav-item")
      if (li) li.classList.toggle("active", Boolean(match))
      if (match) a.setAttribute("aria-current", "location")
      else a.removeAttribute("aria-current")
    })
  }

  const initSectionScrollSpy = (sections, dotLinks = null) => {
    if (!sections.length) return

    const setActive = (id) => {
      if (dotLinks) {
        dotLinks.forEach((link) => {
          const match = link.getAttribute("href") === `#${id}`
          link.classList.toggle("is-active", match)
          if (match) link.setAttribute("aria-current", "location")
          else link.removeAttribute("aria-current")
        })
      }
      syncAnchoredNav(id)
    }

    const clearActive = () => {
      if (dotLinks) {
        dotLinks.forEach((link) => {
          link.classList.remove("is-active")
          link.removeAttribute("aria-current")
        })
      }
      syncAnchoredNav(null)
    }

    const updateFromScroll = () => {
      const line = 2
      const doc = document.documentElement
      const nearBottom = window.innerHeight + window.scrollY >= doc.scrollHeight - 3
      let current = null
      if (nearBottom) {
        current = sections[sections.length - 1]
      } else {
        for (const s of sections) {
          if (s.getBoundingClientRect().top <= line) current = s
        }
      }
      if (current?.id) setActive(current.id)
      else clearActive()
    }

    let ticking = false
    window.addEventListener(
      "scroll",
      () => {
        if (!ticking) {
          requestAnimationFrame(() => {
            ticking = false
            updateFromScroll()
          })
          ticking = true
        }
      },
      { passive: true }
    )
    window.addEventListener("resize", updateFromScroll, { passive: true })
    updateFromScroll()
  }

  const dotsNav = document.querySelector(".section-dots")
  if (dotsNav) {
    const dotLinks = [...dotsNav.querySelectorAll('a[href^="#"]')]
    const sections = dotLinks
      .map((link) => document.getElementById(link.getAttribute("href").slice(1)))
      .filter(Boolean)
    if (sections.length === dotLinks.length) {
      initSectionScrollSpy(sections, dotLinks)

      dotsNav.addEventListener("click", (e) => {
        const a = e.target?.closest?.("a")
        if (!a || !dotsNav.contains(a)) return
        const href = a.getAttribute("href")
        if (!href?.startsWith("#")) return
        const el = document.getElementById(href.slice(1))
        if (!el) return
        e.preventDefault()
        const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches
        el.scrollIntoView({ behavior: reduceMotion ? "auto" : "smooth", block: "start" })
      })
    }
  } else {
    const seen = new Set()
    const sections = []
    document.querySelectorAll('#mainNav .nav-link[href^="#"]').forEach((a) => {
      const href = a.getAttribute("href")
      if (!href || href === "#") return
      const id = href.slice(1)
      if (seen.has(id)) return
      const el = document.getElementById(id)
      if (!el) return
      seen.add(id)
      sections.push(el)
    })
    sections.sort((a, b) => a.offsetTop - b.offsetTop)
    initSectionScrollSpy(sections)
  }

  // Scroll-reveal: dezentes Ein-/Aufblenden, sobald Elemente in den Viewport kommen.
  // Nur aktiv, wenn IntersectionObserver verfügbar ist und keine reduzierte Bewegung
  // gewünscht wird — sonst bleibt alles sichtbar (siehe _reveal.scss).
  const revealEls = [...document.querySelectorAll("[data-reveal]")]
  const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches
  if (revealEls.length && "IntersectionObserver" in window && !prefersReducedMotion) {
    document.documentElement.classList.add("js-reveal")
    const revealObserver = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return
          entry.target.classList.add("is-revealed")
          obs.unobserve(entry.target)
        })
      },
      { rootMargin: "0px 0px -14% 0px", threshold: 0.15 }
    )
    revealEls.forEach((el) => revealObserver.observe(el))
  }
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initSite)
} else {
  initSite()
}
